import React, { useEffect } from "react";
import { Route, Routes, useParams } from "react-router-dom";
import AdvisorLogin from "./pages/AdvisorLogin";
import AdvisorNavigationLayout from "./components/layout/AdvisorNavigationLayout";
import Families from "./pages/Families";
import Family from "./pages/Family";
import FamilyInvitation from "./pages/FamilyInvitation";
import Settings from "./pages/Settings";
import Tools from "./pages/tools/Tools";
import UnassignedEmails from "./pages/tools/UnassignedEmails";
import PhoneCall from "./pages/PhoneCall";
import StatMeThat from "./pages/StatMeThat";
import Tasks from "./pages/Tasks";
import Task from "./pages/Task";
import AdvisorAdminDirectory from "./pages/tools/AdvisorAdministration";
import FamilyDirectory from "./pages/tools/FamilyDirectory";
import FamilyExport from "./pages/tools/FamilyExport";
import ManageRoles from "./pages/tools/ManageRoles";
import ResourcesCms from "./pages/tools/ResourcesCms";
import Reviews from "./pages/tools/Reviews";
import SetupPassword from "./pages/SetupPassword";
import ResetPassword from "./pages/ResetPassword";
import AuditLog from "./pages/tools/AuditLog";
import ForumPost from "./pages/ForumPost";
import Inbox from "./pages/Inbox";
import FeatureSwitches from "./pages/tools/FeatureSwitches";
import Impersonate from "./pages/tools/Impersonate";
import TokenRedirect from "./components/common/TokenRedirect";
import Reports from "./pages/tools/Reports";
import FamilyNotifications from "./pages/tools/FamilyNotifications";
import AdvisorInternalProfile from "./pages/AdvisorInternalProfile";
import ForumTopic from "./pages/ForumPage";
import NotFound from "./components/NotFound";
import { TopicFeed } from "./components/forum/constants";
import Search from "./pages/Search";
import HttpErrorProvider from "./components/context/HttpErrorProvider";
import NuxContextProvider from "./components/context/AdvisorNuxContext";
import Landing from "./pages/nux/advisor/Landing";
import PersonalDetails from "./pages/nux/advisor/PersonalDetails";
import AdvisorAgreement from "./pages/nux/advisor/AdvisorAgreement";
import ContactCard from "./pages/nux/advisor/ContactCard";
import PublicProfile from "./pages/nux/advisor/PublicProfile";
import Finish from "./pages/nux/advisor/Finish";
import NuxWrapper from "./pages/nux/NuxWrapper";
import AdvisorDirectory from "./pages/tools/AdvisorDirectory";
import { USER_NUX_TYPE } from "./components/nux/constants";
import AdvisorPayments from "./pages/tools/AdvisorPayments";
import UrlShortener from "./pages/tools/UrlShortener";
import IdentityLookup from "./pages/tools/IdentityLookup";
import TimeUtilization from "./pages/tools/TimeUtilization";
import FamilyEngagement from "./pages/tools/FamilyEngagement";
import TaskInspiration from "./pages/tools/TaskInspiration";
import TaskDiscovery from "./pages/TaskDiscovery";
import AdvisorCalendar from "pages/AdvisorCalendar";
import CalendarSettings from "pages/CalendarSettings";
import { GlobalModalProvider } from "./components/context/GlobalModalContext";
import PipelineManagement from "./pages/tools/PipelineManagement";
import Document from "./pages/Document";
import Documents from "./pages/Documents";
import DocumentTemplate from "./pages/DocumentTemplate";
import AdvisorHelp from "pages/AdvisorHelp";
import ActivityFeedFilterContextProvider from "components/context/ActivityFeedFilterContext";
import Matchmaking from "pages/tools/Matchmaking";
import Form from "./pages/Form";
import FamilyContext from "pages/tools/FamilyContext";
import FamilyInvoices from "pages/tools/FamilyInvoices";
import AdvisorApplications from "pages/tools/AdvisorApplications";
import Rematching from "pages/tools/Rematching";
import RematchSession from "pages/tools/RematchSession";
import AgentDemo from "pages/tools/agents/Demo";
import AgentPlaybooks from "pages/tools/agents/Playbooks";
import AgentPlaybookDetail from "pages/tools/agents/PlaybookDetail";
import CreatePlaybook from "pages/tools/agents/CreatePlaybook";
import FamilyPrompts from "pages/tools/agents/FamilyPrompts";
import {
  DigitalSubscriptionPlaybooksList,
  DigitalSubscriptionPlaybookDetail,
} from "pages/tools/DigitalSubscriptionPlaybooks";
import ClientAITester from "pages/tools/ClientAITester";
import PipelineMetadata from "pages/tools/PipelineMetadata";
import BadgeManagement from "pages/tools/BadgeManagement";
import ScheduleManagement from "pages/tools/ScheduleManagement";
import Delegations from "pages/tools/Delegations";
import CreateLightningTask from "pages/tools/CreateLightningTask";
import BotConversations from "pages/tools/BotConversations";
import AgentErrors from "pages/tools/AgentErrors";
import TaskOpportunities from "pages/TaskOpportunities";
import TaskSubtaskDetail from "pages/TaskSubtaskDetail";
import VideoCall from "./pages/VideoCall";
import Video from "./pages/Video";
const ADVISOR_SITE_TITLE = "Advisor";

const NUX_ROUTES = [
  { path: "/welcome/landing", component: Landing },
  { path: "/welcome/personal-details", component: PersonalDetails },
  { path: "/welcome/advisor-agreement", component: AdvisorAgreement },
  { path: "/welcome/contact-card", component: ContactCard },
  { path: "/welcome/public-profile", component: PublicProfile },
  { path: "/welcome/finish", component: Finish },
];

const CommunityDocumentsWrapper = () => {
  const { topics } = useParams<{ topics?: string }>();
  return <Documents isCommunity={true} key={topics || "all"} />;
};

export default () => {
  useEffect(() => {
    document.title = ADVISOR_SITE_TITLE;
  }, []);
  return (
    <Routes>
      <Route path={"/login"} element={<AdvisorLogin />} />
      <Route path={"/forgot-password"} element={<ResetPassword />} />
      <Route path={"/token-login/:token?"} element={<TokenRedirect />} />
      <Route
        path={"/setup-account/:token?"}
        element={<SetupPassword isAccountSetup={true} />}
      />
      <Route
        path={"/reset-password/:token?"}
        element={<SetupPassword isAccountSetup={false} />}
      />
      <Route
        path={"/welcome"}
        element={
          <HttpErrorProvider>
            <NuxContextProvider userType={USER_NUX_TYPE.ADVISOR}>
              <NuxWrapper userType={USER_NUX_TYPE.ADVISOR} />
            </NuxContextProvider>
          </HttpErrorProvider>
        }
      >
        {NUX_ROUTES.map(({ path, component: Component }) => (
          <Route key={path} path={path} element={<Component />} />
        ))}
      </Route>
      <Route
        path="/"
        element={
          <GlobalModalProvider>
            <ActivityFeedFilterContextProvider>
              <AdvisorNavigationLayout />
            </ActivityFeedFilterContextProvider>
          </GlobalModalProvider>
        }
      >
        {/* Do we want this? */}
        <Route index element={<ForumTopic treatment={TopicFeed.Home} />} />
        <Route
          path={"/forum"}
          element={<ForumTopic treatment={TopicFeed.Home} />}
        />
        <Route path={"/forum/:postRef"} element={<ForumPost />} />
        <Route
          path={"/community"}
          element={<ForumTopic treatment={TopicFeed.Home} />}
        />
        {(
          [
            ["ask-fas", TopicFeed.AskFAs],
            ["resources", TopicFeed.Resources],
            ["chatter", TopicFeed.Chatter],
            ["recommendations", TopicFeed.Recommendations],
          ] as [string, TopicFeed][]
        ).map((f) => (
          <Route
            key={f[0]}
            path={`/community/${f[0]}`}
            element={<ForumTopic treatment={f[1]} />}
          />
        ))}
        <Route
          path={"/community/topics/:topicQuery"}
          element={<ForumTopic />}
        />
        <Route path={"/community/:postRef"} element={<ForumPost />} />
        <Route path={"/search"} element={<Search />} />
        <Route path={"/families"} element={<Families />} />
        <Route path={"/families/:familyRef"} element={<Family />} />
        <Route
          path={"/families-invitation/:familyRef"}
          element={<FamilyInvitation />}
        />
        <Route path={"/calls/:callRef"} element={<PhoneCall />} />
        <Route path={"/video"} element={<Video />} />
        <Route path={"/video/:uuid"} element={<VideoCall />} />
        <Route path={"/tasks"} element={<Tasks />} />
        <Route path={"/tasks/add"} element={<Task addTask={true} />} />
        <Route path={"/tasks/subtasks"} element={<TaskOpportunities />} />
        <Route
          path={"/tasks/subtasks/active"}
          element={<TaskOpportunities active={true} />}
        />
        <Route path={"/tasks/subtasks/:ref"} element={<TaskSubtaskDetail />} />
        <Route path={"/tasks/:taskRef"} element={<Task />} />
        <Route
          path={"/task-discovery"}
          element={<TaskDiscovery accountType="advisor" />}
        />
        <Route path={"/calendar/:eventRef?"} element={<AdvisorCalendar />} />
        <Route
          path={"/inbox/:inboxType?/create"}
          element={<Inbox create={true} />}
        />
        <Route path={"/inbox/:inboxType?/:ref?"} element={<Inbox />} />
        <Route path={"/tools"} element={<Tools />} />
        <Route
          path={"/tools/advisor-administration/:advisorRef?"}
          element={<AdvisorAdminDirectory />}
        />
        <Route
          path={"/tools/advisor-directory"}
          element={<AdvisorDirectory />}
        />
        <Route path={"/tools/audit-log"} element={<AuditLog />} />
        <Route path={"/tools/family-directory"} element={<FamilyDirectory />} />
        <Route path={"/tools/family-export"} element={<FamilyExport />} />
        <Route path={"/tools/impersonate-user"} element={<Impersonate />} />
        <Route path={"/tools/manage-roles"} element={<ManageRoles />} />
        <Route path={"/tools/resources-cms"} element={<ResourcesCms />} />
        <Route path={"/tools/reviews"} element={<Reviews />} />
        <Route path={"/tools/badge-management"} element={<BadgeManagement />} />
        <Route
          path={"/tools/family-engagement"}
          element={<FamilyEngagement />}
        />
        <Route path={"/tools/feature-switches"} element={<FeatureSwitches />} />
        <Route path={"/tools/url-shortener"} element={<UrlShortener />} />
        <Route path={"/tools/identity-lookup"} element={<IdentityLookup />} />
        <Route
          path={"/tools/unassigned-emails"}
          element={<UnassignedEmails />}
        />
        <Route path={"/tools/time-utilization"} element={<TimeUtilization />} />
        <Route path={"/tools/task-inspiration"} element={<TaskInspiration />} />
        <Route
          path={"/tools/family-notifications"}
          element={<FamilyNotifications />}
        />
        <Route path={"/tools/reports/:reportName?"} element={<Reports />} />
        <Route path={"/tools/advisor-payments"} element={<AdvisorPayments />} />
        <Route
          path={"/tools/pipeline-management/:leadRef?"}
          element={<PipelineManagement />}
        />
        <Route
          path={"/tools/matchmaking/:leadRef?"}
          element={<Matchmaking />}
        />
        <Route
          path={"/tools/rematching/:sessionRef?"}
          element={<Rematching />}
        />
        <Route path={"/tools/family-rematch"} element={<RematchSession />} />
        <Route
          path={"/tools/advisor-applications/:applicationRef?"}
          element={<AdvisorApplications />}
        />
        <Route
          path={"/tools/family-context"}
          element={<FamilyContext adminMode={true} />}
        />
        <Route path={"/tools/family-invoices"} element={<FamilyInvoices />} />
        <Route
          path={"/tools/inspiration-hub"}
          element={<FamilyContext adminMode={false} />}
        />
        <Route path={"/tools/agents/demo"} element={<AgentDemo />} />
        <Route path={"/tools/agents/playbooks"} element={<AgentPlaybooks />} />
        <Route
          path={"/tools/agents/playbooks/new"}
          element={<CreatePlaybook />}
        />
        <Route
          path={"/tools/agents/playbooks/:ref"}
          element={<AgentPlaybookDetail />}
        />
        <Route path={"/prompts"} element={<FamilyPrompts />} />
        <Route
          path={"/tools/digital-subscription-playbooks"}
          element={<DigitalSubscriptionPlaybooksList />}
        />
        <Route
          path={"/tools/digital-subscription-playbooks/:ref"}
          element={<DigitalSubscriptionPlaybookDetail />}
        />
        <Route path={"/tools/client-ai-tester"} element={<ClientAITester />} />
        <Route
          path={"/tools/pipeline-metadata"}
          element={<PipelineMetadata />}
        />
        <Route
          path={"/tools/schedule-management"}
          element={<ScheduleManagement />}
        />
        <Route path={"/tools/delegations"} element={<Delegations />} />
        <Route
          path={"/tools/create-lightning-task"}
          element={<CreateLightningTask />}
        />
        <Route
          path={"/tools/bot-conversations"}
          element={<BotConversations />}
        />
        <Route path={"/tools/agent-errors"} element={<AgentErrors />} />
        <Route path={"/settings"} element={<Settings />} />
        <Route
          path={"/advisor/:advisorRef"}
          element={<AdvisorInternalProfile />}
        />
        <Route
          path={"/settings/calendars/:calendarType?"}
          element={<CalendarSettings accountType="advisor" />}
        />
        <Route
          path={"/documents/community/:topics?"}
          element={<CommunityDocumentsWrapper />}
        />
        <Route
          path={"/templates/open/:uuid"}
          element={<DocumentTemplate mode="open" />}
        />
        <Route
          path={"/templates/create/:uuid"}
          element={<DocumentTemplate mode="create" />}
        />
        <Route path={"/documents/:documentRef"} element={<Document />} />
        <Route path={"/documents"} element={<Documents key="documents" />} />
        <Route
          path={"/forms/complete/:documentRef"}
          element={<Form mode="complete" />}
        />
        <Route
          path={"/forms/view/:documentRef"}
          element={<Form mode="view" />}
        />
        <Route
          path={"/forms/create/:documentRef"}
          element={<Form mode="create" />}
        />
        <Route path={"/advisor/help"} element={<AdvisorHelp />} />
        <Route path="*" element={<NotFound />} />
      </Route>
      <Route path={"/statmethat"} element={<StatMeThat />} />
    </Routes>
  );
};
